export const SCREEN_LARGE = "(min-width: 1280px)";
export const SCREEN_MEDIUM = "(min-width: 800px)";
export const SCREEN_SMALL = "(max-width: 799px)";
